import React from "react";
import DesktopExperts from "./DesktopExperts";
import MobileExprerts from "./MobileExperts";
import styles from "./styles.module.css";

export const EXPERTS_SECTION_ID = "experts";

const Experts = ({ experts }) => {
  return (
    <>
      <div id={EXPERTS_SECTION_ID} className={styles.desktopWrapper}>
        <DesktopExperts experts={experts} />
      </div>
      <div className={styles.mobileWrapper}>
        <MobileExprerts experts={experts} />
      </div>
    </>
  );
};

export default Experts;
